import { render, staticRenderFns } from "./ed-header-sidebar-menu.vue?vue&type=template&id=68f8ccf2&scoped=true&"
import script from "./ed-header-sidebar-menu.ts?vue&type=script&lang=js&"
export * from "./ed-header-sidebar-menu.ts?vue&type=script&lang=js&"
import style0 from "./ed-header-sidebar-menu.scss?vue&type=style&index=0&id=68f8ccf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f8ccf2",
  null
  
)

export default component.exports